import React, { useState, useEffect, useRef} from 'react';
import Presenter from './HeaderPresenter'
import { useQuery } from '@apollo/react-hooks'
import { QUERY } from '../../Queries/isLoggedIn';
import { useHistory } from 'react-router-dom';

export default () => {
  const history = useHistory();
  const { data: { auth: { isLoggedIn } } } = useQuery(QUERY)
  const [profileBtn, setProfileBtn] = useState(false)
  const [windowSize, setWindowSize] = useState(window.innerWidth)
  const loginClick = async () => {
    const urls = `https://accounts.google.com/o/oauth2/auth?client_id=${process.env.REACT_APP_CLIENTID}&redirect_uri=${process.env.NODE_ENV === "development" ? "http://localhost:3000/redirect" : "https://www.thatgeul.com/redirect"}&scope=https://www.googleapis.com/auth/youtube&response_type=code&access_type=offline`
    window.location.assign(urls)
  }
 
  useEffect(() => {
    window.addEventListener("resize", handleSize);
    return () => {
      window.removeEventListener("resize", handleSize);
    };
  });
  const handleSize = ()=>{
    console.log(window.innerWidth)
    setWindowSize(window.innerWidth)
  }
  
  return (
    <Presenter 
      isLoggedIn={isLoggedIn} 
      loginClick={loginClick} 
      history={history}
      profileBtn={profileBtn}
      setProfileBtn={setProfileBtn}
      windowSize={windowSize}
      />
  )
}